import { useReadContract } from "wagmi";

const useApprovalForAllData = (
  userAddress,
  NftMarketPlaceAddress,
  selectedContract,
  selectedAbi
) => {
  return useReadContract({
    address: selectedContract,
    abi: selectedAbi,
    functionName: "isApprovedForAll",
    args: [userAddress, NftMarketPlaceAddress],
  });
};

export default useApprovalForAllData;
